export default __webpack_public_path__ + "static/media/AIG.3bef0c53.png";